var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#376F66",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15V1M1.344 8.5h12.312M7.5 1C6.1 2.4 3.767 3.8.5 4.267c0 0 0 7.933 7 10.733 7-2.8 7-10.733 7-10.733C11.233 3.8 8.9 2.4 7.5 1z"
  }))));
}
export default SvgIconInsurance;